<h2>{{viewContext.entityNamePlural | titlecase}}</h2>


<div class="d-inline-block tenant-selection" ngbDropdown #myDrop="ngbDropdown">
  <label class="tenant-caption">Tenant</label>
  <button
    class="btn btn-outline-primary mr-2"
    id="dropdownManual"
    ngbDropdownAnchor
    (focus)="myDrop.open()">{{getSelectedTenantId()}} - {{getSelectedTenantName()}}
  </button>
  <div ngbDropdownMenu aria-labelledby="dropdownManual">
    <button *ngFor="let tenant of tenants"
            class="dropdown-item"
            (click)="selectTenant(tenant)">
      {{tenant.id}} - {{tenant.name}}
    </button>
  </div>
</div>

<app-array [entities]="entities"
           [listColumns]="getListColumns()"
           [selectedEntity]="selectedEntity"
           (rowOpenRequire)="openCurrentEntityInForm($event)"
           (rowSelected)="onSelect($event)"
           (rowDeleteRequire)="openEntityInDeleteDialog($event)"
           [isShortcutsInUse]="!isOpenViewsOpen()"
>
</app-array>


<app-buttons [buttons]="getButtonsMeta()"
             (buttonPressed)="controlButtonPressed($event)"
             [targetSelected]="!!selectedEntity">
</app-buttons>
